import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
// ngrx store
import { Store } from '@ngrx/store';
// models
import { AppState } from '../../../booking/models/app-state.interface';
// services
import { LoginService } from '../../../shared/services/login.service';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
import { CopyService } from '../../../shared/services/app-copy.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UPDATE_USER_EMAIL } from '@shared/reducers/user.reducer';


@Component({
  selector: 'app-register',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  providers: [
    LoginService
  ]
})
export class RegisterComponent implements OnInit, OnDestroy {

  private _verifyEmailSubscription: Subscription;
  private _userLanguageSubscription: Subscription;
  private _bookingInitSubscription: Subscription;

  public emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  public showLoader: Boolean = false;
  public userEmail;
  public userNotFound: Boolean = false;
  public appCopy;
  public copyLoaded: Boolean = false;
  public selectedLanguage = '';

  constructor(
    private _appStore: Store<AppState>,
    private _loginService: LoginService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _errorHandler: ErrorHandler,
    private _copyService: CopyService,
  ) { }

  ngOnInit() {
    this._userLanguageSubscription = this._appStore.select('copyReducer')
    .subscribe((res: any) => {
    this.selectedLanguage = res.language
    })

    this._copyService.getStaticCopy()
      this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
        .subscribe((res: any) => {
          this.copyLoaded = res.copyLoaded;
            if (res.copyLoaded) {
              this.getCopy();
            }

        })

    this._verifyEmailSubscription = this._loginService.verifyUserSubject$
      .subscribe(res => {
        // response codes
        // Active = 1, Inactive = 2, NotFound = 3
        if (res.verifyCustomerStatus === 1) {
          // full user
          this.showLoader = false;
          this._errorHandler.handleCustomInfo({
            text: "Looks like you already have an account. You'll be redirected back to login.",
            type: 'info'
          });
          this._appStore.dispatch(UPDATE_USER_EMAIL({ userEmail: this.userEmail }));
          setTimeout(() => {
            this._router.navigate(['access-account']);
          }, 2500);
        } else if (res.verifyCustomerStatus === 2 || res.verifyCustomerStatus === 3) {
          // user active, no password - send to validate
          this._loginService.sendResetPassword(this.userEmail, true);
          this._appStore.dispatch(UPDATE_USER_EMAIL({userEmail: this.userEmail }));
          this._router.navigate(['validate-email'], { queryParams: { step2: true, isRegister: true }});
        }
      });
  }

  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      'register',
      ['registerScreen']
    );
    // console.log(panelHeaderCopy)
    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
    };

  }

  handleSubmitEmailCheck(value, e) {
    e.preventDefault();
    this.showLoader = true;
    this.userEmail = value.Username;
    this._loginService.checkEmail(this.userEmail);
  }

  goToLogin() {
    this._router.navigate(['login']);
  }

  ngOnDestroy() {
    this._verifyEmailSubscription.unsubscribe();
    this._userLanguageSubscription.unsubscribe();
    this._bookingInitSubscription.unsubscribe();
  }

}
